import { render } from "./AppFinance.vue?vue&type=template&id=6b9841e2"
import script from "./AppFinance.vue?vue&type=script&lang=js"
export * from "./AppFinance.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__